module.exports = __webpack_public_path__ + "static/media/imgGalleryM5.f50291ca.svg";